import { Flex, VStack } from '@chakra-ui/react'
import React from 'react'
import Block from '../components/shared/Block'
import { BsCheckCircle } from 'react-icons/bs'
import FormInfoPreview from '../components/formstep3/FormInfoPreview'
import { useParams } from 'react-router-dom'
import FormStepPanel from '../components/form/FormStepPanel'
import FinalPanel from '../components/formfinal/FinalPanel'

const FormFinal = () => {
    const { fid } = useParams();
    return (
        <Flex p="40px" direction="column" w="full">
            <Block title="ยืนยันการส่งแบบคำขอเรียบร้อยแล้ว" icon={BsCheckCircle} >
                <VStack w="full">
                    <FormStepPanel step={4} />
                    <FormInfoPreview fid={fid} final={true} collapse={true} showStatus={true} />
                    <FinalPanel />
                </VStack>
            </Block>
        </Flex>
    )
}

export default FormFinal
